<!--INSTRUCTIONS LIST-->
<ng-container *ngIf="showInstructions">
  <aside class="instructions-list">
    <!--INSTRUCTIONS EXPAND COLLAPSE HEADER-->
    <div [ngClass]="instructionContentClass">
      <!--EXAM SCHEDULE ICON-->
      <span class="exam-schedule margin-right-large">
        <i class="icon red small" [ngClass]="icon ? icon : ''"></i>
      </span>
      <!--END EXAM SCHEDULE ICON-->
      <h2 class="margin-bottom-small">{{ title }}</h2>
      <h4 class="align-short-title">{{ shortTitle }}</h4>
      <!--EXPAND COLLAPSE ACCORDION-->
      <span class="margin-left-auto">
        <a class="cursor" (click)="toggleAccordion()">
          <i
            class="icon red small"
            [ngClass]="toggleExpandCollapse ? 'arrow-up' : 'arrow-down'"></i>
        </a>
      </span>
      <!--END EXPAND COLLAPSE ACCORDION-->
    </div>
    <!--END INSTRUCTIONS EXPAND COLLAPSE HEADER-->
    <!--INSTRUCTIONS CONTENT-->
    <!--NOTE: This is an ordered list of instructions-->
    <div class="instructions-content" *ngIf="toggleExpandCollapse">
      <ol class="instructions-step-list">
        <li
          *ngFor="let step of steps; let i = index; let j = index; trackBy: trackByInstructionsId"
          class="flexbox margin-top-small margin-right-small">
          <!--NOTE: Add 1 + index, so first step is step 1, since index starts with zero.-->
          <div class="list-item">
            <span class="circle-number bold">{{ i + 1 }}</span>
          </div>
          <!--NOTE: Steps can contain html hence the inner html, which may include links-->
          <p [innerHTML]="step"></p>
        </li>
      </ol>
    </div>
    <!--END INSTRUCTIONS CONTENT-->
  </aside>
</ng-container>
<!--INSTRUCTIONS LIST-->
